import { render } from "./PlanF.vue?vue&type=template&id=f8bfa58a"
import script from "./PlanF.vue?vue&type=script&lang=js"
export * from "./PlanF.vue?vue&type=script&lang=js"

import "./PlanF.vue?vue&type=style&index=0&id=f8bfa58a&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__